import moment from "moment";

export function formatDate(date : number): string {
    try {
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
    } catch (e) {
        return 'unable to parse date ' + date;
    }
}
